<!--
  ~ Copyright 2020 Google LLC.
  ~ SPDX-License-Identifier: Apache-2.0
  -->

<div id="wrapper"
     (mouseleave)="leaveEnvAndTooltip()">
  <app-tooltip *ngIf="tooltip.show"
               [tooltip]="tooltip"
               [currentSnapshot]="currentSnapshot"
               [currentCandidate]="currentCandidate">
  </app-tooltip>
  <div class="environment-container"
       [ngStyle]="{'padding-bottom': getEnvPaddingBottom(), height: svgHeight + 'px'}">
    <div class="title"
         (click)="handleExpand()">
      <svg class="expand-icon"
           [attr.width]="getTitleHeight()"
           [attr.height]="getTitleHeight()">
        <g>
          <polygon [attr.points]="getExpandIcon()"
                   fill="dimgrey"/>
        </g>
      </svg>
      <p class="title-name"
         [ngStyle]="{
             width: getTitleNameWidth(),
             height: getTitleHeight(),
             'margin-right': TITLE_MARGIN + 'px',
             'font-size': getTitleHeight(),
             overflow: expanded ? 'visible' : 'hidden',
             'white-space': expanded ? 'normal' : 'nowrap',
             'text-overflow': 'ellipsis'}">
        {{environment.name}}
      </p>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg"
         class="env-svg"
         id="{{environment.name}}-svg"
         [attr.width]="svgWidth"
         [attr.height]="svgHeight"
         (mouseenter)="enteredEnvironment($event)"
         (mouseleave)="leftEnvironment()"
         (mousemove)="envMouseMove($event)"
         (mousedown)="envMouseDown($event)"
         (mouseup)="envMouseUp($event)">
      <line [attr.x1]="0"
            [attr.y1]="0"
            [attr.x2]="svgWidth"
            [attr.y2]="0"
            stroke="gray"/>
      <line *ngIf="!expanded"
            [attr.x1]="0"
            [attr.y1]="svgHeight"
            [attr.x2]="svgWidth"
            [attr.y2]="svgHeight"
            stroke="gray"/>
      <polygon class="cand-polygon"
               *ngFor="let polygon of polygons"
               [attr.points]="polygon.toAttributeString()"
               [attr.fill]="getColor(polygon)"
               [attr.fill-opacity]="getOpacity(polygon)"
               (mouseenter)="enteredPolygon(polygon)"
               (mouseleave)="leftPolygon(polygon)"/>
      <rect *ngIf="shouldDisplayLine()"
            id="cur-snapshot-line"
            [attr.x]="getLineX() - 1"
            [attr.y]="0"
            [attr.width]="2"
            [attr.height]="expanded ? svgHeight - TIMELINE_HEIGHT + 10 : svgHeight"
            fill="white"/>
      <text id="no-data"
            *ngIf="displayedSnapshots.length === 0"
            [attr.x]="svgWidth / 2"
            [attr.y]="svgHeight / 2"
            [attr.fill]="getThemeTextColor()">
        No data for this period
      </text>
      <g id="timeline" *ngIf="expanded">
        <rect [attr.x]="0"
              [attr.y]="svgHeight - TIMELINE_HEIGHT + 10"
              [attr.width]="svgWidth" [attr.height]="2"
              fill="gray"/>
        <text *ngFor="let timelinePoint of timelinePoints; let i = index"
              [attr.x]="timelinePoint.x"
              [attr.y]="svgHeight - 12"
              [attr.fill]="getThemeTextColor()"
              [attr.text-anchor]="environmentService.getTimelinePointTextAlignment(i, timelinePoints)"
              font-size="12">
          {{ timelinePoint.timeString }}
        </text>
        <text *ngFor="let timelinePoint of timelinePoints; let i = index"
              [attr.x]="timelinePoint.x"
              [attr.y]="svgHeight"
              [attr.fill]="getThemeTextColor()"
              [attr.text-anchor]="environmentService.getTimelinePointTextAlignment(i, timelinePoints)"
              font-size="12">
          {{ timelinePoint.dateString }}
        </text>
        <line
          *ngFor="let timelinePoint of timelinePoints"
          [attr.x1]="timelinePoint.x"
          [attr.y1]="svgHeight - TIMELINE_HEIGHT + 2"
          [attr.x2]="timelinePoint.x"
          [attr.y2]="svgHeight - TIMELINE_HEIGHT / 2 - 3"
          stroke="gray"/>
      </g>
      <g id="drag-region"
         *ngIf="dragStartTimestamp">
        <rect id="drag-rect"
              [attr.x]="dragMinX"
              [attr.y]="0"
              [attr.width]="dragMaxX - dragMinX"
              [attr.height]="expanded ? svgHeight - TIMELINE_HEIGHT + 10 : svgHeight"
              [attr.fill]="getThemeTextColor()"
              opacity="0.5"/>
        <line class="drag-edge"
              [attr.x1]="dragMinX"
              [attr.y1]="0"
              [attr.x2]="dragMinX"
              [attr.y2]="expanded ? svgHeight - TIMELINE_HEIGHT + 10 : svgHeight"
              [attr.stroke]="getThemeTextColor()"/>
        <line class="drag-edge"
              [attr.x1]="dragMaxX"
              [attr.y1]="0"
              [attr.x2]="dragMaxX"
              [attr.y2]="expanded ? svgHeight - TIMELINE_HEIGHT + 10 : svgHeight"
              [attr.stroke]="getThemeTextColor()"/>
      </g>
    </svg>
  </div>
</div>
